const lifehack3 = ($star, $backstar, $dot1, $dot2, $dot3) => {
	new TimelineMax()
		.to([$star, $backstar], 5, {
			scale: 0.75,
			paused: false,
			repeat: -1,
			rotationZ: -0.0001,
			yoyo: true,
			ease: Linear.easeNone,
			clearProps: 'true',
		})
		.from($dot1, 1, {
			opacity: 0,
			paused: false,
			repeat: -1,
			rotationZ: -0.0001,
			ease: Linear.easeNone,
			yoyo: true,
			clearProps: 'true',
		}, 0)
		.from($dot2, 1, {
			opacity: 0,
			paused: false,
			repeat: -1,
			rotationZ: -0.0001,
			ease: Linear.easeNone,
			yoyo: true,
			clearProps: 'true',
		}, 0.5)
		.from($dot3, 1, {
			opacity: 0,
			paused: false,
			repeat: -1,
			rotationZ: -0.0001,
			ease: Linear.easeNone,
			yoyo: true,
			clearProps: 'true',
		}, 1);
};

export default lifehack3;
